<table class="table table-eddy mt-3">
  <thead>
    <tr>
      <th scope="col" style="width: 30%">Produto</th>
      <th scope="col" style="width: 15%; text-align: center;">Lote</th>
      <th scope="col" style="width: 12%; text-align: center;">Vencimento</th>
      <th scope="col" style="width: 10%; text-align: center;">Requisitado</th>
      <th scope="col" style="width: 10%; text-align: center;">Saldo</th>
      <th scope="col" style="width: 13%; text-align: center;">Aceito</th>
      <th scope="col" style="width: 90px"></th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let item of lista; let idx = index">
      <tr>
        <td style="width: 30%">
          <span *ngIf="!(item.editavel && item.produto_unidade_troca)" class="float-left">
            <u>{{item.produto_unidade.produto.codigo}}</u>
            {{funcaoService.abreviarStr(item.produto_unidade.produto.nome, 80)}} -
            <b>{{item.produto_unidade.unidade.nome}}</b>
          </span>
          <p-autoComplete *ngIf="item.editavel && item.produto_unidade_troca" id="rec"
            [(ngModel)]="item.produto_unidade.produto" [forceSelection]="true" [autoHighlight]="true"
            [ngModelOptions]="{standalone: true}" [field]="produtoAutoComplete.conversor"
            [suggestions]="produtoAutoComplete.lista" (completeMethod)="produtoAutoComplete.filtrar($event)"
            (onSelect)="carregarUnidades(item)" inputStyleClass="form-control form-control-sm" minLength="2"
            [style]="{ width: '75%' }">
            <ng-template let-produto pTemplate="item">
              {{produto.codigo}} {{produto.nome}}
            </ng-template>
          </p-autoComplete>
          <select *ngIf="item.editavel && item.produto_unidade_troca" [compareWith]="compareFn" id="produto_unidade"
            [(ngModel)]="item.produto_unidade" [ngModelOptions]="{standalone: true}"
            class="form-control form-control-sm float-right" style="width: 25%;" (change)="carregarLotes(item)">
            <option [ngValue]="undefined">---</option>
            <option [ngValue]="item" *ngFor="let item of listProdUn">
              {{item.unidade.nome}}
            </option>
          </select>
          <br />
          <!--visualizar justificativa de troca-->
          <span *ngIf="!item.editavel && item.produto_unidade_troca" style="word-break: break-all;"
            class="text-danger float-left">
            {{item.justificativa_troca}}
          </span>
          <!--visualizar justificativa de troca-->
        </td>
        <td [attr.colspan]="item.editavel && !requisicao.devolucao ? '2' : '1'" class="text-center">
          <span *ngIf="!item.editavel ||  requisicao.devolucao">
            {{item.lote}}
          </span>
          <p-autoComplete *ngIf="item.editavel && !requisicao.devolucao" styleClass="form-control form-control-sm p-0" [forceSelection]="true"
            [autoHighlight]="true" [inputStyle]="{'font-size' : '12px'}" [ngModel]="{lote : item.lote, vencimento: item.vencimento}"
            (ngModelChange)="onChangeLote(item,$event)" [suggestions]="listLoteVecFiltro" [style]="{ width: '100%' }"
            (completeMethod)="buscarLoteVencimento($event)" [field]="conversorLote" [dropdown]="true">
            <ng-template let-itemL pTemplate="item">
              <div class="d-flex jutify-content-between align-items-center" style="font-size: 12px;">
                <div class="d-flex flex-column justify-content-center align-items-start">
                  <span><b>LOTE:</b> {{itemL.lote}}</span>
                  <span><b>VENCIMENTO:</b> {{itemL.vencimento | date : 'dd/MM/yyyy' : 'GMT'}}</span>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-end ml-2">
                  <span><b>SALDO {{requisicao.devolucao ? 'DEVOLUÇÂO' : ''}}:</b></span>
                  <span>{{(requisicao.devolucao ? itemL.saida : itemL.saldo_atual) | number:'1.5-5'}}</span>
                </div>
              </div>
            </ng-template>
          </p-autoComplete>
        </td>
        <td *ngIf="!item.editavel ||  requisicao.devolucao" class="text-center">
          <span> {{item.vencimento | date:'dd/MM/yyyy':'GMT'}} </span>
        </td>
        <td style="width: 10%; text-align: center">
          <span>
            {{item.qtd_requisitada | number:'1.5-5'}}
          </span>
        </td>
        <td style="width: 10%; text-align: center">
          <span>
            {{ (requisicao.devolucao ? item.saida : item.saldo_atual) | number:'1.5-5'}}
          </span>
        </td>
        <td style="width: 13%; text-align: center">
          <span *ngIf="!item.editavel">
            {{item.qtd_aceita | number:'1.5-5'}}
          </span>
          <input #qtde_aceite [style]="{ width: 'calc(100% - 32px)', float: 'left' }" *ngIf="item.editavel" id="qtde"
            [(ngModel)]="item.qtd_aceita" [ngModelOptions]="{standalone: true}" type="text"
            class="form-control form-control-sm text-right" unmask="true" [imask]="imaskValor" unmask="typed"
            [imask]="imaskValor" (keyup.enter)="salvar(item)">
          <button *ngIf="item.editavel" class="btn btn-sm btn-outline-secondary float-right text-secondary"
            type="button" style="border-bottom-left-radius: 0px;  border-top-left-radius: 0px;"
            (click)="valorTotal(item)">
            <i class="fa fa-download"></i>
          </button>
        </td>
        <td class="text-right" style="width: 110px;">
          <button *ngIf="item.editavel && !somenteVisualizar" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary"
            style="min-width: 37px;">
            <i class="fa fa-check text-success"></i>
          </button>
          <button *ngIf="item.editavel && !somenteVisualizar" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary ml-2"
            style="min-width: 37px;">
            <i class="fa fa-close text-danger"></i>
          </button>
          <button *ngIf="!item.editavel && !somenteVisualizar" [disabled]="disabled()" (click)="editar(item)"
            class="btn btn-sm btn-outline-primary" style="min-width: 37px;">
            <i class="fa fa-edit text-dark"></i>
          </button>
          <button title="Trocar" *ngIf="!item.editavel && !item.produto_unidade_troca && !somenteVisualizar && !requisicao.devolucao" (click)="trocar(item)"
            style="min-width: 37px;" class="btn btn-sm btn-outline-secondary ml-2">
            <i class="fa fa-undo text-dark"></i>
          </button>
          <button  title="Reverter Troca" *ngIf="!item.editavel && item.produto_unidade_troca && !somenteVisualizar && !requisicao.devolucao"
            (click)="reverterTroca(item)" style="min-width: 37px;"
            class="btn btn-sm btn-outline-secondary ml-2">
            <i class="fa fa-undo text-danger"></i>
          </button>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
<app-troca-item-requisicao-dlg [item]="itemTroca" (itemChange)="trocatItem($event)" [requisicao]="requisicao"
  [(visualizar)]="visualizarTroca"></app-troca-item-requisicao-dlg>